import {
  CHANGE_STATUS_ORDER,
  GET_SPLIT_ORDER,
  REVERT_TO_QUOTE,
  SEND_MAIL_ORDER,
} from './../../utils/constants/actionType';
// Libs
import { createAsyncThunk } from '@reduxjs/toolkit';
// Others
import orderApi from '~/apis/order';
import {
  CONVERT_ORDER_TO_JOB,
  DELETE_ORDER,
  GET_LIST_ORDER,
  GET_LIST_ORDER_EVENT,
  GET_ORDER_DETAIL,
  SPLIT_ORDER,
  UPDATE_ORDER,
} from '~/utils/constants/actionType';
import { IBodyUpdate } from '~/utils/interface/common';
import {
  IBodyChangeStatusOrder,
  IBodySplitOrder,
  IParamQueryOrder,
  IParamQueryOrderDetail,
  IParamQueryOrderSplit,
  IQueryParamOrderEvent,
} from '~/utils/interface/order';

export const getListOrder = createAsyncThunk(GET_LIST_ORDER, async (params: IParamQueryOrder, { rejectWithValue }) => {
  try {
    const resp = await orderApi.getListOrder(params);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const deleteOrder = createAsyncThunk(DELETE_ORDER, async (id: string, { rejectWithValue }) => {
  try {
    const resp = await orderApi.deleteOrder(id);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const getListOrderEvent = createAsyncThunk(
  GET_LIST_ORDER_EVENT,
  async (params: IQueryParamOrderEvent, { rejectWithValue }) => {
    try {
      const resp = await orderApi.getListOrderEvent(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const convertOrderToJob = createAsyncThunk(
  CONVERT_ORDER_TO_JOB,
  async (orderId: string, { rejectWithValue }) => {
    try {
      const resp = await orderApi.convertOrderToJob(orderId);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getOrderDetail = createAsyncThunk(
  GET_ORDER_DETAIL,
  async (params: IParamQueryOrderDetail, { rejectWithValue }) => {
    try {
      const resp = await orderApi.getOrderDetail(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const getOrderSplit = createAsyncThunk(
  GET_SPLIT_ORDER,
  async (params: IParamQueryOrderSplit, { rejectWithValue }) => {
    try {
      const resp = await orderApi.getOrderSplit(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const splitOrder = createAsyncThunk(SPLIT_ORDER, async (payload: IBodySplitOrder, { rejectWithValue }) => {
  try {
    const resp = await orderApi.splitOrder(payload);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const updateOrder = createAsyncThunk(
  UPDATE_ORDER,
  async (params: IBodyUpdate<FormData>, { rejectWithValue }) => {
    try {
      const resp = await orderApi.updateOrder(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const sendMailOrder = createAsyncThunk(
  SEND_MAIL_ORDER,
  async (params: IBodyUpdate<FormData>, { rejectWithValue }) => {
    try {
      const resp = await orderApi.sendMailOrder(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const revertToQuote = createAsyncThunk(REVERT_TO_QUOTE, async (orderId: string, { rejectWithValue }) => {
  try {
    const resp = await orderApi.revertToQuote(orderId);
    return resp.data;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const changeStatusOrder = createAsyncThunk(
  CHANGE_STATUS_ORDER,
  async (params: IBodyUpdate<IBodyChangeStatusOrder>, { rejectWithValue }) => {
    try {
      const resp = await orderApi.changeStatusOrder(params);
      return resp.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
